import { useQuery } from "@tanstack/react-query";

import { getCropMixComposerScoreFactors } from "services";

import { GET_CROP_MIX_COMPOSER_SCORE_FACTORS } from "consts";

import { ScoreFactors } from "models";

export const useGetCropMixComposerScoreFactors = () =>
  useQuery<ScoreFactors>({
    queryKey: [GET_CROP_MIX_COMPOSER_SCORE_FACTORS],
    queryFn: getCropMixComposerScoreFactors,
  });
